import { SvgIcon, SvgIconProps, useTheme } from '@mui/material';

/**
 * CcfMinusIcon used to disply plus icon in the contact card channel panel
 * @param props - SvgIconProps
 * @example -- <CcfMinusIcon />
 */
export function CcfMinusIcon(props: SvgIconProps) {
  const theme = useTheme();
  return (
    <SvgIcon fill={props?.fill} {...props}>
     
      <rect id="Rectangle_37572" data-name="Rectangle 37572" width="36" height="36" transform="translate(-3 -3)" fill="gray" opacity="0"/>
      <path id="minus" d="M0 0.0944824H18.1648V2.44958H0V0.0944824Z" transform="translate(3.8 3.801)" fill={props?.fill ?props.fill : theme.palette.secondary.main}/>
      
    </SvgIcon>
  );
}

export default CcfMinusIcon;
